<script>
	// Import general mixin for shared functionality.
	import mixin from '../../mixin';

	// Import primevue components
	import DataTable from 'primevue/datatable';
	import Column from 'primevue/column';

	// Import JS Excel library
	import * as XLSX from 'xlsx';

	export default {
		mixins: [mixin],
		components: {
			DataTable,
			Column,
		},
		props: {
			dossiers: Array,
			columns: Array,
			exportFilename: String,
			sortfield: {
				type: String,
				default: '',
			},
            lazyLoading: Boolean,
		},
		data() {
			return {
				editedColumns: [...this.columns],
				sortObj: {
					order: -1,
                    field: this.sortfield,
				},
			};
		},
		computed: {
			computedColumns() {
				return this.editedColumns;
			},
			computedDossiers() {
				return this.dossiers;
				/*TODO FE: Code below might be obsolete, if functionality is OK it can be removed*/

				//if (!this.sortObj.field) return this.dossiers;

				//return [...this.dossiers].sort((a, b) => {
				//	const valueA = a[this.sortObj.field];
				//	const valueB = b[this.sortObj.field];

				//	if (valueA === valueB) return 0;
				//	if (valueA === null || valueA === undefined) return this.sortObj.order;
				//	if (valueB === null || valueB === undefined) return -this.sortObj.order;

				//	const isNumericValue = (value) =>
				//		typeof value === 'number' || /^-?\d+(\.\d+)?$/.test(value);

				//	if (isNumericValue(valueA) && isNumericValue(valueB)) {
				//		return (Number(valueA) - Number(valueB)) * this.sortObj.order;
				//	}

				//	return valueA.localeCompare(valueB) * this.sortObj.order;
				//});
			},
			scrollHeight() {
				return this.dossiers.length < 10 ? `${this.dossiers.length * 50 + 50}px` : '500px';
			},
		},
		methods: {
			async exportCSV() {
                if (this.computedDossiers.some(dossier => !dossier.dossier_nr)) {
                    await new Promise((resolve) => {
                        this.$emit('loadAll', resolve);
                    });
                }
				this.$refs.dt.exportCSV();
			},
			async exportExcel() {
				if (this.computedDossiers.some(dossier => !dossier.dossier_nr)) {
                    await new Promise((resolve) => {
                        this.$emit('loadAll', resolve);
                    });
				}
				const data = this.computedDossiers;
				const columns = this.computedColumns;
				const customHeaders = columns.map((col) => col.label);
				const excelData = data.map((row) => {
					return columns.map((col) => {
						const value = row[col.field];

						if (col.type === 'currency') {
							return this.nullCheck(this.toEuro(value, true));
						} else if (col.type === 'percentage') {
							return this.nullCheck(this.toPercentage(value));
						} else if (col.type === 'date') {
							return this.nullCheck(this.toDateStr(value));
						} else if (col.type === 'nullableNumber') {
							return this.nullableNumberCheck(value);
						} else {
							return this.nullCheck(value);
						}
					});
				});
				excelData.unshift(customHeaders);
				const worksheet = XLSX.utils.aoa_to_sheet(excelData);
				const workbook = XLSX.utils.book_new();
				XLSX.utils.book_append_sheet(workbook, worksheet, 'Blad 1');
				XLSX.writeFile(workbook, `${this.exportFilename}.xlsx`);
			},
			freezeColumn(event, selectedColumn) {
				event.preventDefault();
				const column = this.editedColumns.find(
					(column) => column.label === selectedColumn.label
				);
				column.frozen = !column.frozen;
			},
			nullCheck(value) {
				return value || '-';
			},
			nullableNumberCheck(value) {
				return value || 0;
			},
			sort(event, column) {
				let order = 1;
				if (this.sortObj.field === column.field && this.sortObj.order === 1) order = -1;
				this.sortObj = {
                    order: order,
                    field: column.field,
				};
                this.$emit('sort', this.sortObj);
			},
			openDropdown() {
				this.$refs.dropdown.classList.toggle('is-active');
				document.addEventListener('click', (event) => {
					if (this.$refs.dropdown && !this.$refs.dropdown.contains(event.target)) {
						this.$refs.dropdown.classList.remove('is-active');
					}
				});
			},
			loadLazy(metadata) {
				this.$emit('loadLazy', metadata);
			},
		},
	};
</script>

<template>
	<DataTable v-if="dossiers.length"
			   ref="dt"
			   scrollable
			   :scrollHeight="scrollHeight"
			   :virtualScrollerOptions="{ lazy: true, onLazyLoad: loadLazy, itemSize: 30, step: 10000 }"
			   :value="dossiers"
			   :pt="{
					table: 'table table--small table--datatable is-bordered is-fullwidth',
				}"
			   :exportFilename="exportFilename"
			   @sort="sort">
		<template #header>
			<div class="dropdown mb-2" ref="dropdown">
				<div class="dropdown-trigger has-background-white" @click="openDropdown">
					<button :class="[
                            'button',
                            $store.getters.getHighContrast ? 'is-quaternary' : 'is-tertiary',
                            'is-outlined',
                        ]"
							aria-haspopup="true"
							aria-controls="dropdown-menu">
						<span class="icon">
							<i class="fa-solid fa-file-export"></i>
						</span>
						<span>{{ $store.getters.getText('dashboardLabelExport') }}</span>
						<span class="icon">
							<i class="fa-solid fa-angle-down" aria-hidden="true"></i>
						</span>
					</button>
				</div>
				<div class="dropdown-menu" id="dropdown-menu" role="menu">
					<div class="dropdown-content">
						<a @click="exportCSV" class="dropdown-item">
							<span class="icon"><i class="fa-solid fa-file-csv"></i></span>
							<span>{{ $store.getters.getText('dashboardLabelCsv') }}</span>
						</a>
						<a @click="exportExcel" class="dropdown-item">
							<span class="icon"><i class="fa-solid fa-file-excel"></i></span>
							<span>{{ $store.getters.getText('dashboardLabelExcel') }}</span>
						</a>
					</div>
				</div>
			</div>
		</template>
		<Column :header="$store.getters.getText('dashboardLabelNumber')" :frozen="true">
			<template #body="slotProps">
				{{ slotProps.index + 1 }}
			</template>
		</Column>
		<Column v-for="column of computedColumns"
				:key="column.field"
				:field="column.field"
				:header="column.label"
				:frozen="column.frozen">
			<template #header>
				<span class="icon is-clickable" @click="freezeColumn($event, column)">
					<i :class="['fa-solid', 'fa-sm', column.frozen ? 'fa-lock' : 'fa-lock-open',]"></i>
				</span>
				<span :class="['icon', 'icon--sort', 'is-clickable', { 'soft-hide': column.field != sortObj.field },]" @click="sort($event, column)">
					<i :class="['icon--sort-i', 'fa-solid', 'fa-lg', column.field === sortObj.field && sortObj.order === 1 ? 'fa-caret-up' : 'fa-caret-down',]"></i>
				</span>
			</template>
			<template v-if="column.type === 'currency'" #body="slotProps">
				<p class="has-text-right">{{ nullCheck(toEuro(slotProps.data[column.field], true)) }}</p>
			</template>
			<template v-if="column.type === 'percentage'" #body="slotProps">
				<p class="has-text-right">{{ nullCheck(toPercentage(slotProps.data[column.field])) }}</p>
			</template>
			<template v-if="column.type === 'date'" #body="slotProps">
				{{ nullCheck(toDateStr(slotProps.data[column.field])) }}
			</template>
			<template v-if="column.type === 'link'" #body="slotProps">
				<a :href="column.url + slotProps.data[column.field] + '000'" target="_blank">{{ nullCheck(slotProps.data[column.field]) }}</a>
			</template>
			<template v-if="column.type === 'amount'" #body="slotProps">
				<p class="has-text-right">{{ nullCheck(slotProps.data[column.field]) }}</p>
			</template>
			<template v-if="column.type === 'nullableNumber'" #body="slotProps">
				<p class="has-text-right">{{ nullableNumberCheck(slotProps.data[column.field]) }}</p>
			</template>
			<template #body="slotProps">
				{{ nullCheck(slotProps.data[column.field]) }}
			</template>
		</Column>
	</DataTable>
</template>
